import { endpoints } from "@app/api/apis"
import ROUTE from "@app/navigationApp/routes"
import Button from "@app/sharedComponents/Button/Button"
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { useAppSelector } from "@app/store/hooks"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import { formatIndianCurrency } from "@app/utils/utility"
import axios from "axios"
import { ScrollView,Image } from "react-native"


const OldForeClosure = ({navigation}) =>{
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const creditInfo = useAppSelector((state) => state.auth.creditDetails);
        
    
    const continueForeclosure = () => {
        const url = endpoints.foreclosureValidationAndDetails + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
            navigation.navigate(ROUTE.REPAY_DUES)
        })
    }
    return(
        <>
            <PageHeaders label="Foreclose your loan" pageName="OldForclosure" navigation={navigation}/>
            <ScrollView style={{flex:1,backgroundColor:themeColorSet["bg-surface-page"]}}>
                <ThemedView my="2xl" p="lg" alignItems="center" backgroundColor="bg-surface-primary">
                    <ThemedText color="text-secondary">Your credit line</ThemedText>
                    <ThemedText color="text-emphasis-secondary">₹{formatIndianCurrency(creditInfo?.availableCreditAmount)}</ThemedText>
                    <ThemedText color="text-secondary">is available for FREE till 1 Jan, 2024</ThemedText>
                    <ThemedView py="lg" px="xl" backgroundColor="bg-fill-secondary" borderRadius="lg" mt="lg" flexDirection="row" justifyContent="space-between" alignItems="center">
                        <ThemedView alignItems="center" flex={1} flexWrap="wrap">
                            <Image source={{uri : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_flash.png"}} style={{width:36, height : 36 }}/>
                            <ThemedText variant="b4m" color="text-secondary" textAlign="center">Get instant cash</ThemedText>
                        </ThemedView>
                        <ThemedView height={'80%'} width={1} backgroundColor="border-secondary" mx="md"/>
                        <ThemedView  alignItems="center" flex={1} flexWrap="wrap">
                            <Image source={{uri : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_percent.png"}} style={{width:36, height : 36 }}/>
                            <ThemedText variant="b4m"  color="text-secondary" textAlign="center">Portfolio keeps growing</ThemedText>
                        </ThemedView>
                        <ThemedView height={'80%'} width={1} backgroundColor="border-secondary" mx="md"/>
                        <ThemedView  alignItems="center" flex={1} flexWrap="wrap">
                            <Image source={{uri : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_lock.png"}} style={{width:36, height : 36 }}/>
                            <ThemedText variant="b4m" color="text-secondary" textAlign="center">Investments are safe </ThemedText>
                        </ThemedView>

                    </ThemedView>
                </ThemedView>
                <ThemedView p="lg" backgroundColor="bg-surface-primary" >
                    <ThemedText variant="h5s" color="text-primary" mb="lg">Foreclose your loan anytime without any hidden charges</ThemedText>
                    <ThemedView position='relative'>
            <ThemedView flexDirection='row' mb="2xl">
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >1</ThemedText>
                </ThemedView>
                <ThemedView ml="md"  flexWrap='wrap' flex={1}>
                    <ThemedText variant='b3m' color="text-secondary">Raise a request for foreclosure anytime</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView position='absolute' left={15} top={15} zIndex={-1} height={75} width={1} backgroundColor='border-secondary' />
            <ThemedView flexDirection='row' mb="2xl" position='relative' >
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >2</ThemedText>
                </ThemedView>
                <ThemedView ml="md"  flexWrap='wrap' flex={1}>
                    <ThemedText variant='b3m' color="text-secondary">Make payments on existing dues</ThemedText>
                </ThemedView>
            </ThemedView>
            <>
            <ThemedView position='absolute' left={15} bottom={50} zIndex={-1} height={100} width={1} backgroundColor='border-secondary' />
            <ThemedView flexDirection='row'  >
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >3</ThemedText>
                </ThemedView>
                <ThemedView ml="md" flexWrap='wrap' flex={1}>
                    <ThemedText variant='b3m' color="text-secondary">We will approve the request to release collateral within 1-2 business days</ThemedText>
                </ThemedView>
            </ThemedView>
            </>
        </ThemedView>
                </ThemedView>
            </ScrollView>
            <ThemedView backgroundColor="bg-surface-primary" p="lg" >
                <Button label="Proceed to foreclose loan" handlePress={continueForeclosure}/>
            </ThemedView>
        </>
    )
}

export default OldForeClosure